export const APPLICATION_BASE_URL = "https://api.w3pl.xyz"